import React, {useEffect, useState} from "react";
import {Formik, Field} from "formik";
import {BusinessFormDetailsValidation} from "../AddBusinessValidation";
import RadioField from "../../../../../components/radio-field/RadioField";
import {InputField} from "../../../../../components/input-field/InputField";
import {Button} from "../../../../../components";
import {SectionsProps} from 'models';

export const DetailsSection: React.FC<SectionsProps> = ({
                                                            setSectionName,
                                                            changeStep,
                                                            setNewBusinessInfo,
                                                            newBusinessInfo
                                                        }) => {
    useEffect(() => {
        setSectionName('Business Details')
    }, [setSectionName]);

    const [business_types] = useState([
        "Sole Trader",
        "Company Limited",
        "Association",
        "Partnership",
        "Group/Co-operation",
        "Other",
    ])

    const [initialValues] = useState({
        details: newBusinessInfo?.details
    });

    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({...prevInfo, details: values.details}))
        changeStep && changeStep("next")
        setSubmitting(false);
    }

    return (
        <div className={'add-business-section'}>
            <p className={'info'}>
                <span>Note:</span> Lorem Ipsum is simply dummy text of the printing and typesetting industry.
            </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormDetailsValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input'}>
                            <div className={'add-business-section_input_radio'}>
                                <span>Is your business registered?</span>
                                <div>
                                    <RadioField
                                        id={'details.is_registered'}
                                        name={'details.is_registered'}
                                        text={'Yes'}
                                        onchange={handleChange}
                                        value={'yes'}
                                        checked={values.details.is_registered === 'yes'}
                                    />
                                    <RadioField
                                        id={'details.is_registered'}
                                        name={'details.is_registered'}
                                        text={'No'}
                                        onchange={handleChange}
                                        value={'no'}
                                        checked={values.details.is_registered === 'no'}
                                    />
                                </div>
                                <span id="--name__error" className="inputField_info_wrapper_message">
                                                {errors.details?.is_registered && touched.details?.is_registered && errors.details?.is_registered}
                                            </span>
                            </div>
                            <InputField
                                id={"details.registration_number"}
                                type="text"
                                classname="signup__input"
                                placeholder={"Business Registration Number"}
                                name="details.registration_number"
                                onblur={handleBlur}
                                error={errors.details?.registration_number && touched.details?.registration_number}
                                onchange={handleChange}
                                message={errors.details?.registration_number && touched.details?.registration_number && errors.details?.registration_number}
                                inputValue={values.details?.registration_number}
                                label={'Business Registration Number'}
                            />
                            <InputField
                                id={"details.tax_registration_number"}
                                type="text"
                                classname="signup__input"
                                placeholder={"Tax Registration Number"}
                                name="details.tax_registration_number"
                                onblur={handleBlur}
                                error={errors.details?.tax_registration_number && touched.details?.tax_registration_number}
                                onchange={handleChange}
                                message={errors.details?.tax_registration_number && touched.details?.tax_registration_number && errors.details?.tax_registration_number}
                                inputValue={values.details?.tax_registration_number}
                                label={"Tax Registration Number"}
                            />

                            <div className={'add-business-section_input_radio'}>
                                <span>Is this business New?</span>
                                <div>
                                    <RadioField
                                        id={'details.is_new'}
                                        name={'details.is_new'}
                                        text={'Yes'}
                                        onchange={handleChange}
                                        value={'yes'}
                                        checked={values.details.is_new === 'yes'}
                                    />
                                    <RadioField
                                        id={'details.is_new'}
                                        name={'details.is_new'}
                                        text={'No'}
                                        onchange={handleChange}
                                        value={'no'}
                                        checked={values.details.is_new === 'no'}
                                    />
                                </div>
                                <span id="--name__error" className="inputField_info_wrapper_message">
                                                {errors.details?.is_new && touched.details?.is_new && errors.details?.is_new}
                                            </span>
                            </div>
                            <div className={'add-business-section_input_radio'}>
                                <span>Business Type:</span>
                                <Field
                                    name="details.business_type"
                                    id={"details.business_type"}
                                    as="select"
                                    onBlur={handleBlur}
                                    error={errors.details?.business_type && touched.details?.business_type}
                                    onChange={handleChange}
                                    value={values.details?.business_type}
                                    className={'signup__input inputField_container_input  '}
                                >
                                    <option id={'b_t_i_default'} value="" disabled hidden>Select Business Type
                                    </option>
                                    {
                                        business_types.map((type, index) => (

                                            <option key={'b_t_i' + type + index} value={type}>{type}</option>
                                        ))
                                    }
                                </Field>
                                <span id="--name__error"
                                      className="inputField_info_wrapper_message">{errors.details?.business_type && touched.details?.business_type && errors.details?.business_type}
                                </span>
                            </div>
                        </div>
                        <div className={'add-business-section_cta'}>
                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>

        </div>
    );
};

